/** Parse dump dates like `20251231` or `2025-12-31` → comparable YYYYMMDD number. */
export const parseV0Date = (raw: unknown): number | null => {
  if (raw == null || String(raw).trim() === '') return null;
  const m = String(raw).trim().match(/^(\d{4})-?(\d{2})-?(\d{2})/);
  if (!m) return null;
  return Number(`${m[1]}${m[2]}${m[3]}`);
};

export const formatV0Date = (raw: unknown): string => {
  const n = parseV0Date(raw);
  if (n == null) return raw == null || String(raw).trim() === '' ? '—' : String(raw);
  const s = String(n);
  return `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}`;
};

export const todayYyyymmdd = (): number => {
  const d = new Date();
  return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
};

export const isAbbonamentoActive = (
  dataFine: unknown,
  today = todayYyyymmdd()
): boolean => {
  const fine = parseV0Date(dataFine);
  return fine != null && fine >= today;
};
